import React from 'react'
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { ICON, RADIUS, STATUS } from '../../theme/tokens'

/**
 * Inline error surface for failed mutations. Render conditionally:
 *   {error && <ErrorBanner message={error} />}
 */
const ErrorBanner = ({ message }) => (
    <Box
        role="alert"
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            background: STATUS.error.bg,
            border: `1px solid ${STATUS.error.border}`,
            borderRadius: `${RADIUS.sm}px`,
            px: 1.5,
            py: 1,
        }}
    >
        <ErrorOutlineIcon sx={{ fontSize: ICON.md, color: STATUS.error.fg }} />
        <Typography variant="body2" sx={{ color: STATUS.error.fg }}>
            {message}
        </Typography>
    </Box>
)

ErrorBanner.propTypes = {
    message: PropTypes.string.isRequired,
}

export default ErrorBanner
